import styled from 'styled-components';
import { media } from '@/styles/responsive';

export const Wrapper = styled.div`
  max-width: 640px;
  margin: 0 auto;
  padding-top: 24px;
`;

export const Intro = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.colors['neutral-70']};
  margin: 0 0 32px;
  line-height: 1.6;
`;

export const OptionGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 32px;
`;

export const OptionCard = styled.button<{ $variant: 'primary' | 'secondary' | 'tertiary' }>`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 20px;
  border-radius: 12px;
  border: 2px solid ${({ $variant, theme }) =>
    $variant === 'primary' ? theme.colors['primary-60'] : theme.colors['neutral-20']};
  background: ${({ $variant, theme }) =>
    $variant === 'primary' ? `${theme.colors['primary-60']}08` : theme.colors['neutral-0']};
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: all 200ms cubic-bezier(0.2, 0.8, 0.4, 1);
  min-height: 44px;
  -webkit-tap-highlight-color: transparent;
  width: 100%;

  &:hover {
    border-color: ${({ $variant, theme }) =>
      $variant === 'primary' ? theme.colors['primary-60'] : theme.colors['neutral-50']};
    background: ${({ $variant, theme }) =>
      $variant === 'primary' ? `${theme.colors['primary-60']}10` : theme.colors['secondary-20']};
  }

  &:active {
    background: ${({ theme }) => theme.colors['secondary-20']};
  }

  ${media.mobile} {
    padding: 16px;
    gap: 12px;
  }
`;

export const IconCircle = styled.div<{ $variant: 'primary' | 'secondary' | 'tertiary' }>`
  width: 44px;
  height: 44px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: ${({ $variant }) => {
    switch ($variant) {
      case 'primary':
        return '#EEF2FF';
      case 'secondary':
        return '#F0FDF4';
      case 'tertiary':
        return '#F4F4F5';
      default:
        return '#F4F4F5';
    }
  }};
  color: ${({ $variant }) => {
    switch ($variant) {
      case 'primary':
        return '#054AD9';
      case 'secondary':
        return '#16A34A';
      case 'tertiary':
        return '#71717A';
      default:
        return '#71717A';
    }
  }};
`;

export const OptionInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const OptionTitle = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors['neutral-100']};
  margin-bottom: 4px;
`;

export const OptionDesc = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.colors['neutral-70']};
  line-height: 1.5;
`;

export const Badge = styled.span`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  background: #EEF2FF;
  color: #054AD9;
  border: 1px solid #C7D2FE;
  flex-shrink: 0;
  margin-top: 2px;
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 4px 0;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: ${({ theme }) => theme.colors['neutral-20']};
  }
`;

export const DividerText = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors['neutral-70']};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;
